import useTranslation from '@/hooks/use-translation';
import { useMedia } from '@drivekyte/ui';

type FooterContentLink = {
  urlTitle: string;
  url: string;
  onPress?: never;
  keepCurrentTab?: boolean;
};

type FooterContentOnPress = {
  urlTitle: string;
  onPress: () => void;
  url?: never;
  keepCurrentTab?: boolean;
};

type FooterContent = {
  sectionTitle: string;
  links: (FooterContentLink | FooterContentOnPress)[];
};

const useFooterContent = (): FooterContent[] => {
  const media = useMedia();
  const { t } = useTranslation('pages.home-page.footer');

  return [
    {
      sectionTitle: t('get-started.title'),
      links: [
        ...(!media.gtSm
          ? [
              {
                urlTitle: t('get-started.download-kyte'),
                url: '/download',
              },
            ]
          : []),
        {
          urlTitle: t('get-started.book-a-car'),
          url: '#book-a-car-section',
          keepCurrentTab: true,
        },
        {
          urlTitle: t('get-started.driver-partners'),
          url: 'https://team.kyte.com/driver-partner',
        },
      ],
    },
    {
      sectionTitle: t('resources.title'),
      links: [
        {
          urlTitle: t('resources.account'),
          url: '/account',
        },
        {
          urlTitle: t('resources.my-trips'),
          url: '/my-trips',
        },
        {
          urlTitle: t('resources.help'),
          url: '?open_support=help',
        },
        {
          urlTitle: t('resources.referral'),
          url: '/invite-friends',
        },
        {
          urlTitle: t('resources.contact-us'),
          url: 'https://help.kyte.com/en/articles/8677830-contact-us',
        },
        {
          urlTitle: t('resources.cookie-settings'),
          onPress: () =>
            window?.revisitCkyConsent ? window?.revisitCkyConsent() : undefined,
        },
      ],
    },
    {
      sectionTitle: t('company.title'),
      links: [
        {
          urlTitle: t('company.company-blog'),
          url: '/company',
        },
        {
          urlTitle: t('company.blog'),
          url: '/blog',
        },
        {
          urlTitle: t('company.careers'),
          url: 'https://jobs.lever.co/kyte',
        },
        {
          urlTitle: t('company.team-and-culture'),
          url: 'https://team.kyte.com/team',
        },
        {
          urlTitle: t('company.tos'),
          url: '/docs/tos',
        },
        {
          urlTitle: t('company.privacy-policy'),
          url: '/docs/privacy-policy',
        },
        {
          urlTitle: t('company.accessibility'),
          url: '/accessibility',
        },
      ],
    },
  ];
};

export default useFooterContent;
